<template>
  <div class="deskblock">
    <h3>待办事项</h3>
    <Row>
      <Col class="daiban" span="12" v-for="(item, index) in items" :key="index">
        <a @click="goto(item)">
          <h2>{{ item.num }}</h2>
          <p>{{ item.title }}</p></a
        >
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          num: 0,
          title: "订单待调度",
          path: "/shangmentihuo",
          disabled: true,
        },
        {
          num: 0,
          title: "订单待分单",
          path: "/fendanpeizai",
          disabled: true,
        },
        {
          num: 0,
          title: "财务待审核",
          path: "/caiwushenhe",
          disabled: true,
        },
        {
          num: 0,
          title: "订单待开票",
          path: "/kaipiaoguanli",
          disabled: true,
        },
      ],
    };
  },
  methods: {
    getData() {
      ///cloud-tms-server-omc/orders/indexPendingCount
      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-omc/orders/indexPendingCount",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        this.items[0].num = data.dispatchPendingCount;
        this.items[1].num = data.pdpzPendingCount;
        this.items[2].num = data.financePendingCount;
        this.items[3].num = data.ticketPendingCount;
      });
    },
    getMenu() {
      var mm = this.$store.state.nav;
      var m = [];
      for (let i = 0; i < mm.length; i++) {
        if (mm[i].type == 1) {
          m.push(mm[i]);
        }
      }
      var t = this.items;

      for (let i = 0; i < m.length; i++) {
        if (m[i].childList.length > 0) {
          for (let j = 0; j < m[i].childList.length; j++) {
            m[i].childList[j].now = i;
            for (let z = 0; z < t.length; z++) {
              if (t[z].path == m[i].childList[j].link) {
                t[z].disabled = false;
                t[z].now = i;
                t[z].name = m[i].childList[j].name;
                t[z].id = m[i].childList[j].id;
              }
            }
          }
        }
      }
    },
    goto(v) {
      if (v.disabled) {
        return;
      } else {
        this.$router.push({
          path: v.path,
          query: { now: v.now },
        });
      }
      var row = {
        name: v.name,
        link: v.path,
        now: v.now,
        id: v.id,
      };
      var result = this.$store.state.topMenuList.some((item) => {
        if (item.id == row.id) {
          return true;
        }
      });
      if (!result) {
        //row.now = this.$route.query.now;
        this.$store.state.topMenuList.push(row);
      }
    },
  },
  computed: {
    nav() {
      this.getMenu();
    },
  },
  watch: {
    nav(m) {},
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="">
.deskblock .daiban {
  text-align: center;
  margin-top: 20px;
}
.deskblock .daiban h2 {
  margin-bottom: 10px;
  font-weight: bold;
  color: #2882f7;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/block4.vue